import { IoDocumentTextOutline, IoClose } from 'react-icons/io5';

type DocumentPreviewProps = {
  fileName: string;
  fileType: string;
  onRemove?: () => void;
  isUploaded?: boolean;
  isUploading?: boolean;
};

const getFileIcon = (fileType: string) => {
  if (fileType.includes('pdf')) return 'text-red-500';
  if (fileType.includes('word') || fileType.includes('doc')) return 'text-blue-500';
  if (fileType.includes('sheet') || fileType.includes('excel') || fileType.includes('csv')) return 'text-green-500';
  return 'text-gray-500';
};

const DocumentPreview = ({ fileName, fileType, onRemove, isUploaded = false, isUploading = false }: DocumentPreviewProps) => {
  return (
    <div
      className={`flex items-center gap-2.5 p-2.5 rounded-xl border ${
        isUploaded ? 'bg-white border-gray-200 shadow-sm' : 'bg-purple-50 border-purple-100'
      }`}
      style={{ maxWidth: '100%' }}
    >
      {isUploading ? (
        <div className="h-6 w-6 flex-shrink-0 flex items-center justify-center">
          <div className="h-4 w-4 border-2 border-purple-300 border-t-purple-600 rounded-full animate-spin" />
        </div>
      ) : (
        <IoDocumentTextOutline className={`text-2xl flex-shrink-0 ${getFileIcon(fileType)}`} />
      )}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-800 truncate">{fileName}</p>
        <p className="text-[10px] text-gray-400 uppercase tracking-wide">
          {isUploading
            ? 'indexing...'
            : fileType.split('/').pop()?.replace('application/vnd.openxmlformats-officedocument.', '').replace('application/', '') || fileType}
        </p>
      </div>
      {onRemove && !isUploading && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="flex-shrink-0 text-gray-300 hover:text-red-500 transition-colors p-1 rounded-full hover:bg-gray-100"
          type="button"
        >
          <IoClose size={16} />
        </button>
      )}
    </div>
  );
};

export default DocumentPreview;